<template>
  <div v-if="isShow" v-loading="loading" class="radish-left">
    <div class="radish-head">
      <div class="radish-title">解析结果</div>
      <div class="radish-btns"><div class="radish-btn" @click="close">关闭</div></div>
    </div>
    <div v-if="ready" class="radish-body">
      <div class="radish-box">
        <div class="radish-btn radish-btn-primary" style="float:right" @click="mergeField">替换选中的字段</div>
        <div class="radish-btn radish-btn-primary" style="float:right" @click="mergeAll">替换全部数据(包括经历)</div>
        <div style="line-height:1.5">
          <b style="font-size:13px">说明：</b><br />
          以下为本次简历解析内容：<br />
          1.红色字体是与旧数据不同的内容，请确认是否补全替换；<br />
          2.替换字段过程人选内容已经保存，无需二次点击保存；<br />
        </div>
        <el-checkbox v-model="checkAll" :indeterminate="isIndeterminate" @change="handleCheckAllChange"
          >全选</el-checkbox
        >
        <el-checkbox-group v-model="checkedItem" @change="handleCheckedItemChange">
          <div v-for="(dt, k) in formData" :key="k">
            <el-checkbox :label="k">
              <span :style="itemStyle(k)">{{ k + ':' + dt }}</span>
            </el-checkbox>
          </div>
        </el-checkbox-group>
        <br />
      </div>
      <template v-if="!isNew">
        <div v-for="(edt, key) in formExpData" :key="key" class="radish-box">
          <div>
            <b>{{ key }}:</b>
          </div>
          <div v-for="(eItem, kItem) in edt" :key="kItem" class="radish-box-content">
            <div v-for="(e, kk) in eItem" :key="kk">
              <b>{{ kk }}:</b> {{ e }}
            </div>
            <div class="radish-btn-text" style="position:absolute;right:20px;top:5px;" @click="mergeExp(key, eItem)">
              添加 <i class="el-icon-d-arrow-right"></i>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import { fieldsAll, fieldsExp } from './constant/fields-add'
import { formatCvData, isArrEq } from './constant/common-methods'

export default {
  props: {
    onModifyField: { type: Function, default: () => {} },
    onAddOneExp: { type: Function, default: () => {} },
    onModifyAll: { type: Function, default: () => {} },
  },
  data: function() {
    return {
      isShow: false,
      ready: false,
      loading: false,
      fieldsAll: fieldsAll,
      fieldsExp: fieldsExp,
      formData: {},
      formExpData: {
        教育: [],
        工作: [],
        项目: [],
      },
      rid: '',
      radish: {},
      diffFields: [],
      isNew: false,
      checkAll: false,
      checkedItem: [],
      isIndeterminate: false,
    }
  },
  methods: {
    attachParse: async function(md5) {
      this.ready = false
      this.loading = true
      const doc = await app.service('file').analyse({ md5, force: true })
      if (!doc || Object.keys(doc).length === 0) {
        this.$message.error('未能解析出内容')
        this.loading = false
        this.close()
        return
      }
      // if (doc) {
      const { radishData, expData } = formatCvData(doc)
      delete radishData.人选画像预测
      // 重复时去掉手机号
      if (radishData.手机) {
        const dup = await app.service('radish').duplicate({ phone: radishData['手机'] })
        if (dup.msg === 'duplicate') {
          delete radishData.手机
        }
      }
      const fields = Object.keys(radishData)
      this.diffFields = fields.filter(f => {
        if (radishData[f] instanceof Array) {
          if (!(this.radish[f] instanceof Array)) {
            return false
          }
          return !isArrEq(radishData[f], this.radish[f])
        } else {
          return radishData[f] != this.radish[f]
        }
      })
      this.formData = radishData
      this.formExpData = expData
      // } else {
      //   this.$message.error()
      //   this.isShow = false
      // }
      // console.log(this.formData)
      this.ready = true
      this.loading = false
    },
    itemStyle(field) {
      return this.diffFields.includes(field) ? 'color:#f00' : ''
    },
    handleCheckAllChange(val) {
      this.checkedItem = val ? Object.keys(this.formData) : []
      this.isIndeterminate = false
    },
    handleCheckedItemChange(value) {
      const checkedCount = value.length
      const itemLength = Object.keys(this.formData).length
      this.checkAll = checkedCount === itemLength
      this.isIndeterminate = checkedCount > 0 && checkedCount < itemLength
    },
    mergeAll: function(main) {
      if (this.diffFields.includes('姓名')) {
        this.$confirm(
          '新增简历内容中姓名与系统原有人选不一致，请再次确认为同一人员，以免造成数据错误',
          '提示：姓名不一致，仍要替换？',
          {
            confirmButtonText: '是，仍要替换',
            cancelButtonText: '否',
          },
        )
          .then(() => {
            this.doMergeAll()
          })
          .catch(() => {})
      } else {
        this.doMergeAll()
      }
    },
    doMergeAll: async function() {
      this.loading = true
      const n = JSON.parse(JSON.stringify(this.formData))
      const edt = JSON.parse(JSON.stringify(this.formExpData))
      const nExp = []
      for (const key in edt) {
        for (const item of edt[key]) {
          if (Object.keys(item).length > 0) {
            item.rid = this.rid
            item.type = key
            nExp.push(item)
          }
        }
      }
      // console.log(nExp)
      const data = [
        {
          o: { _id: this.rid },
          n: n,
          nExp: nExp,
        },
      ]
      // console.log(data)
      const res = await app.service('radish').merge({
        data: data,
        main: 'n',
        from: 'cv',
      })
      if (res.status == 'success') {
        this.$message.success({ duration: 500, message: '成功' })
        this.onModifyAll()
        this.close()
      } else {
        this.$message.error(res.msg)
      }
      this.loading = false
    },
    mergeField: async function() {
      // console.log(this.rid)
      if (this.checkedItem.length == 0) {
        this.$message.warning('请先选择')
        return
      }
      const dt = {}
      for (const k in this.formData) {
        if (this.checkedItem.includes(k)) {
          const v = this.formData[k]
          if (k == '地域' && typeof v === 'string') {
            dt[k] = v.split(';')
          } else {
            dt[k] = v
          }
        }
      }
      const result = await app.service('radish').modifyById({ _id: this.rid, data: dt })
      // console.log(result)
      if (result.status == 'success') {
        this.$message.success({ duration: 500, message: '成功' })
        this.ready = false
        for (const key of this.checkedItem) {
          delete this.formData[key]
        }
        this.checkedItemm = []
        this.onModifyField(dt)
        this.ready = true
      } else {
        this.$message.error(res.msg)
      }
    },
    mergeExp: async function(type, exp) {
      // console.log(type,exp)
      exp.type = type
      exp.rid = this.rid
      const eRes = await app.service('radish').addExperience(exp)
      // console.log(eRes)
      if (eRes.status == 'success') {
        this.$message.success({ duration: 500, message: '成功' })
        exp._id = eRes.data.ids[0]
        this.onAddOneExp(type, exp)
      }
    },
    open: async function(md5, rid, radish) {
      if (!md5 || !rid) {
        this.$message.warning('parsepreview参数错误')
        return
      }
      this.rid = rid
      if (!radish || Object.keys(radish).length == 0) {
        const res = await app
          .service('radish')
          .simpleFetch({ _id: rid, fields: { 任职经历: 0, 旧系统沟通备注: 0, 沟通日志: 0 } })
        this.radish = res.data
      } else {
        this.radish = radish
      }
      this.$confirm('该文件已存为人选附件，即将进入新旧简历对比，此简历为人选最新简历么？', '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '是（将自动替换经历）',
        cancelButtonText: '否（进入手动内容对比）',
      })
        .then(async () => {
          this.isNew = true
          await this.attachParse(md5)
          this.ready = true
          this.isShow = true

          // this.formData = { "姓名": "王慧", "性别": "女", "年龄": "30", "地域": "北京", "手机": "18611820783", "邮箱": "447924611@qq.com", "婚育": "未婚" };
          // this.formExpData = { "教育": [ { "学校": "格拉斯哥大学", "专业": "国际会计与财务管理", "学历": "硕士", "起始时间": "2010.09", "结束时间": "2011.09" }, { "学校": "苏州大学", "专业": "会计学", "学历": "本科", "起始时间": "2006.08", "结束时间": "2010.06" } ], "工作": [ { "公司": "平安证券股份有限公司", "目前职位": "实习生", "下属人数": "0", "工作职责": "信用/债券研究员(买方) 2016.09-至今\n职责业绩: 1.对拟投资债券进行分析、出具信评意见并对发行人资质进行持续跟踪,主要负责城投、医药、轻工、商贸流通等行业;\n2.对持仓债每月进行跟踪排查风险,并每天对涉及持仓债的舆情进行点评;\n3.完善公司内部打分卡,维护债券库;\n4.对持仓债进行调研,并参与其他机构组织的调研和交流会;\n5. 负责城投信用策略研究,通过分析城投行业信用利差和超额利差来挖掘区域级别和期限价值、排查区域风险\n6.定期进行行业研究和专题研究,并撰写行业研究/专题研究报告\n7. 协助it进行评级系统功能的开发与完善\n8.查看各种公众号公布的信息,了解债券市场信用趋势和各种政策", "起始时间": "2016.09", "结束时间": "至今", "当前公司": true }, { "公司": "联合资信评估有限公司", "目前职位": "信用评级分析师", "下属人数": "0", "工作职责": "职责业绩: 1.工商企业评级,主要负责产业债,包括尽职调研、撰写信用评级报告、风险排查、跟踪观察;\n2.工商企业行业梳理及行业研究报告;\n3.工商企业前期研究及级别初步判定;\n4.参加公司信用评级会议评审企业主体及债项级别。\n负责项目:包括新希望六和股份有限公司、正大(中国)投资有限公司、岳阳林纸股份有限公司、东莞玖龙纸业有限公司、山东鲁信投资控股集团有限公司、四川长虹电子控股集团有限公司、广州汽车集团股份有限公司等,约上百个项目,项目类型包括短融、中票(包含永续中票)、企业债、非标项目。", "起始时间": "2014.02", "结束时间": "2016.09" }, { "公司": "东方华尔金融咨询有限公司", "目前职位": "项目经理", "下属人数": "2", "工作职责": "职责业绩: 1. 参与翻译、编写、校对cfa辅导教材。\n2. 搜集相关财经新闻,定期向公司内部资讯杂志发表文章。\n3. 作为讲师负责编写授课ppt,并参与讲授证券投资基金和财务管理。\n4. 负责海外培训项目方案制作和运行。", "起始时间": "2011.10", "结束时间": "2014.02" } ], "项目": [ { "项目名称": "东莞玖龙纸业有限公司2016年第一期中票", "项目职务": "项目负责人", "项目职责": "项目职责: 作为项目负责人,负责该项目的尽职调查和前期资料准备,与项目各参与方(主承销商、企业、律所)进行沟通,对公司所在行业进行研究和分析,结合调研和行业分析,对公司主体和债项撰写信用评级报告,并对公司基本面进行持续跟踪和风险排查。", "起始时间": "2016.03", "结束时间": "2016.04" }, { "项目名称": "四川长虹电子控股集团有限公司2016年第二期中票项目", "项目职务": "项目负责人", "项目职责": "项目职责: 作为项目负责人,负责该项目的尽职调查和前期资料准备,与项目各参与方(主承销商、企业、律所)进行沟通,对公司所在行业进行研究和分析,结合调研和行业分析,对公司主体和债项撰写信用评级报告,并对公司基本面进行持续跟踪和风险排查。", "起始时间": "2015.11", "结束时间": "2015.12" }, { "项目名称": "河南投资集团有2015年第二期中票-永续中票", "项目职务": "项目负责人", "项目职责": "项目职责: 作为项目负责人,负责该项目的尽职调查和前期资料准备,与项目各参与方(主承销商、企业、律所)进行沟通,对公司所在行业进行研究和分析,结合调研和行业分析,对公司主体和债项撰写信用评级报告,并对公司基本面进行持续跟踪和风险排查。", "起始时间": "2015.05", "结束时间": "2015.06" }, { "项目名称": "新希望六和股份有限公司2015年第一期短融", "项目职务": "项目负责人", "项目职责": "项目职责: 作为项目负责人,负责对该项目进行尽职调查,与项目各参与方(主承销商、企业、律所)进行沟通,对公司所在行业进行研究和分析,结合调研和行业分析,对公司主体和债项撰写信用评级报告,并对公司基本面进行持续跟踪和风险排查。", "起始时间": "2015.05", "结束时间": "2015.06" }, { "项目名称": "山东鲁信集团2015年6亿元企业债", "项目职务": "项目负责人", "项目职责": "项目职责: 作为项目负责人,负责该项目前期的尽职调查,与项目各参与方(主承销商、企业、律所)进行沟通,对公司所在行业(造纸)进行研究和分析,结合调研和行业分析,对公司主体和债项撰写信用评级报告,并对公司基本面进行持续跟踪和风险排查。\n项目业绩:", "起始时间": "2014.11", "结束时间": "2014.12" } ] };

          // 替换exp
          this.loading = true
          await app.service('radish').deleteExpByRid({ rid: this.rid })
          const edt = JSON.parse(JSON.stringify(this.formExpData))
          let nExp = []
          for (const key in edt) {
            for (const item of edt[key]) {
              if (Object.keys(item).length > 0) {
                item.rid = this.rid
                item.type = key
                nExp.push(item)
              }
            }
          }
          if (nExp.length > 0) {
            await app.service('radish').addExperience(nExp)
            // 替换任职经历
            nExp = nExp.filter(e => e.type == '工作')
            await app.service('radish').modifyRenzhi({ _id: this.rid, exp: nExp })
            this.onModifyAll()
          }
          this.loading = false
        })
        .catch(async action => {
          if (action === 'cancel') {
            this.isNew = false
            await this.attachParse(md5)

            // this.formData = { "姓名": "王慧", "性别": "女", "年龄": "30", "地域": "北京", "手机": "18611820783", "邮箱": "447924611@qq.com", "婚育": "未婚" };
            // this.formExpData = { "教育": [ { "学校": "格拉斯哥大学", "专业": "国际会计与财务管理", "学历": "硕士", "起始时间": "2010.09", "结束时间": "2011.09" }, { "学校": "苏州大学", "专业": "会计学", "学历": "本科", "起始时间": "2006.08", "结束时间": "2010.06" } ], "工作": [ { "公司": "平安证券股份有限公司", "目前职位": "实习生", "下属人数": "0", "工作职责": "信用/债券研究员(买方) 2016.09-至今\n职责业绩: 1.对拟投资债券进行分析、出具信评意见并对发行人资质进行持续跟踪,主要负责城投、医药、轻工、商贸流通等行业;\n2.对持仓债每月进行跟踪排查风险,并每天对涉及持仓债的舆情进行点评;\n3.完善公司内部打分卡,维护债券库;\n4.对持仓债进行调研,并参与其他机构组织的调研和交流会;\n5. 负责城投信用策略研究,通过分析城投行业信用利差和超额利差来挖掘区域级别和期限价值、排查区域风险\n6.定期进行行业研究和专题研究,并撰写行业研究/专题研究报告\n7. 协助it进行评级系统功能的开发与完善\n8.查看各种公众号公布的信息,了解债券市场信用趋势和各种政策", "起始时间": "2016.09", "结束时间": "至今", "当前公司": true }, { "公司": "联合资信评估有限公司", "目前职位": "信用评级分析师", "下属人数": "0", "工作职责": "职责业绩: 1.工商企业评级,主要负责产业债,包括尽职调研、撰写信用评级报告、风险排查、跟踪观察;\n2.工商企业行业梳理及行业研究报告;\n3.工商企业前期研究及级别初步判定;\n4.参加公司信用评级会议评审企业主体及债项级别。\n负责项目:包括新希望六和股份有限公司、正大(中国)投资有限公司、岳阳林纸股份有限公司、东莞玖龙纸业有限公司、山东鲁信投资控股集团有限公司、四川长虹电子控股集团有限公司、广州汽车集团股份有限公司等,约上百个项目,项目类型包括短融、中票(包含永续中票)、企业债、非标项目。", "起始时间": "2014.02", "结束时间": "2016.09" }, { "公司": "东方华尔金融咨询有限公司", "目前职位": "项目经理", "下属人数": "2", "工作职责": "职责业绩: 1. 参与翻译、编写、校对cfa辅导教材。\n2. 搜集相关财经新闻,定期向公司内部资讯杂志发表文章。\n3. 作为讲师负责编写授课ppt,并参与讲授证券投资基金和财务管理。\n4. 负责海外培训项目方案制作和运行。", "起始时间": "2011.10", "结束时间": "2014.02" } ], "项目": [ { "项目名称": "东莞玖龙纸业有限公司2016年第一期中票", "项目职务": "项目负责人", "项目职责": "项目职责: 作为项目负责人,负责该项目的尽职调查和前期资料准备,与项目各参与方(主承销商、企业、律所)进行沟通,对公司所在行业进行研究和分析,结合调研和行业分析,对公司主体和债项撰写信用评级报告,并对公司基本面进行持续跟踪和风险排查。", "起始时间": "2016.03", "结束时间": "2016.04" }, { "项目名称": "四川长虹电子控股集团有限公司2016年第二期中票项目", "项目职务": "项目负责人", "项目职责": "项目职责: 作为项目负责人,负责该项目的尽职调查和前期资料准备,与项目各参与方(主承销商、企业、律所)进行沟通,对公司所在行业进行研究和分析,结合调研和行业分析,对公司主体和债项撰写信用评级报告,并对公司基本面进行持续跟踪和风险排查。", "起始时间": "2015.11", "结束时间": "2015.12" }, { "项目名称": "河南投资集团有2015年第二期中票-永续中票", "项目职务": "项目负责人", "项目职责": "项目职责: 作为项目负责人,负责该项目的尽职调查和前期资料准备,与项目各参与方(主承销商、企业、律所)进行沟通,对公司所在行业进行研究和分析,结合调研和行业分析,对公司主体和债项撰写信用评级报告,并对公司基本面进行持续跟踪和风险排查。", "起始时间": "2015.05", "结束时间": "2015.06" }, { "项目名称": "新希望六和股份有限公司2015年第一期短融", "项目职务": "项目负责人", "项目职责": "项目职责: 作为项目负责人,负责对该项目进行尽职调查,与项目各参与方(主承销商、企业、律所)进行沟通,对公司所在行业进行研究和分析,结合调研和行业分析,对公司主体和债项撰写信用评级报告,并对公司基本面进行持续跟踪和风险排查。", "起始时间": "2015.05", "结束时间": "2015.06" }, { "项目名称": "山东鲁信集团2015年6亿元企业债", "项目职务": "项目负责人", "项目职责": "项目职责: 作为项目负责人,负责该项目前期的尽职调查,与项目各参与方(主承销商、企业、律所)进行沟通,对公司所在行业(造纸)进行研究和分析,结合调研和行业分析,对公司主体和债项撰写信用评级报告,并对公司基本面进行持续跟踪和风险排查。\n项目业绩:", "起始时间": "2014.11", "结束时间": "2014.12" } ] };

            this.ready = true
            this.isShow = true
          }
        })
    },
    close: function() {
      this.isShow = false
      if (this.$route.name == 'radish-detail-blank') {
        window.location.reload()
      }
    },
  },
}
</script>
